import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Labs",
  [
    [
      "path",
      {
        d: "M16.72,8.01c-.2-.12-.33-.32-.33-.55V1.83h.61c.47,0,.86-.38.86-.86s-.38-.86-.86-.86H6.75c-.47,0-.86.38-.86.86s.38.86.86.86h.61v5.63c0,.23-.12.43-.33.55-2.96,1.73-4.8,4.92-4.8,8.35,0,2.51.96,4.89,2.7,6.7.47.49,1.15.76,1.92.76h10.06c.77,0,1.45-.27,1.93-.76,1.74-1.81,2.7-4.18,2.7-6.7,0-3.42-1.84-6.62-4.8-8.35ZM16.9,22.09H6.85c-.42,0-.62-.16-.69-.23-1.26-1.31-2.04-3.01-2.19-4.82.02-.02.05-.04.07-.07.02-.02.04-.04.08-.07.05-.05.14-.12.26-.21.22-.17.58-.42,1.07-.68.88-.46,2.32-1,4.23-1,1.62,0,2.6.51,3.84,1.17.08.04.16.08.24.12l.15.08c1.35.7,3.02,1.45,5.75,1.55-.3,1.48-1.01,2.83-2.06,3.92-.07.07-.27.23-.69.23ZM9.68,13.3c-2.26,0-3.98.65-5.02,1.2-.21.11-.4.22-.57.32.44-2.24,1.81-4.17,3.8-5.32.73-.42,1.18-1.2,1.18-2.03V1.83h5.61v5.63c0,.83.45,1.61,1.18,2.03,2.4,1.4,3.9,3.97,3.95,6.73-2.43-.08-3.86-.71-5.12-1.36l-.39-.21c-1.27-.67-2.58-1.36-4.62-1.36Z",
      },
    ],
  ],
  "currentColor"
);
